<template>
  <b-modal id="inventoryModalForm"
           ref="inventoryModalForm"
           title="Consulta e Manutenção de Inventário"
           ok-title="Finalizar"
           close-title="Fechar"
           cancel-title="Cancelar"
           size="lg"
           no-close-on-esc
           no-close-on-backdrop
           :ok-disabled=form.errors.any()
           v-model="inventoryModalShow"
           @ok="onFinished">
    <form @submit.stop.prevent="onFinished">
      <b-row class="pb-1 pr-0">
        <b-col>
          <b-input autofocus type="text" ref="barcode" v-on:keyup.enter="onScan()" v-model="barcode"></b-input>
        </b-col>
        <b-col>
          <b-btn :disabled="loading" @click="onScan()" variant="secondary">Escanear código</b-btn>
        </b-col>
        <b-col md="2" class="p-0">
          <b-input hidden disabled type="text"></b-input>
        </b-col>
      </b-row>
      <b-row class="pb-1 pr-0 align-items-end">
        <b-col sm="6" md="3" class="p-a-0 m-t-5px">
          <div class="fl-flex-label fl-collapsed fl-background">
            <input type="text" class="form-control" v-model="descr" ref="descr"/>
            <label class="fl-label" style="left: 13px; right: 12px">Descrição</label>
          </div>
        </b-col>
        <b-col sm="6" md="2" class="p-a-0 m-t-5px">
          <div class="fl-flex-label fl-collapsed fl-background">
            <input type="text" class="form-control" v-model="invoiceGroupId" ref="invoiceGroupId" readonly/>
            <label class="fl-label"
                   style="left: 13px; right: 12px; background: rgba(255,255,255,0); top: -3px">Grupo</label>
          </div>
        </b-col>
        <b-col sm="6" md="2" class="p-a-0 m-t-5px">
          <div class="fl-flex-label fl-collapsed fl-background">
            <h6 class="ml-1">
              Qtde. volumes bipados: {{ this.volumesBiped }}
            </h6>
          </div>
        </b-col>
      </b-row>
    </form>
    <div class="loadingDataPosition">
      <div class="loadingData" v-if="loading"></div>
      <vuetable ref="vuetable"
                :api-mode="false"
                :fields="fields"
                :data="invoiceVolumesBiped"
                :css="css"
                track-by="docfisvol_id"
                pagination-path=""
                @vuetable:load-error="onError"
                no-data-template="Nenhum dado de volume para mostrar. Faça a primeira bipagem"
                @vuetable:pagination-data=""
                @vuetable:loaded="onLoaded"
                class="table-responsive-sm"
      >
        <template v-slot:actions="props">
          <a :aria-disabled="loading" @click="removeVolumeBeep(props.rowData)" v-b-tooltip title="Remover volume"><i
              class="fa fa-times"></i></a>
        </template>
      </vuetable>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="onFinished()" :disabled="isDisabled" variant="secondary" class="mr-1">
          Finalizar
        </b-btn>
        <b-btn @click="onClose()" variant="secondary">
          Fechar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from '../components/AvisoErros'
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import {formatToBrazilianDate} from "../utils";

export default {
  components: {
    AvisoErros,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
  },
  data() {
    return {
      barcode: '',
      descr: '',
      docfisvolbipgrp_id: '',
      invoiceGroupId: '',
      volumesBiped: 0,
      description: '',
      invoiceVolume: '',
      loading: false,
      isDisabled: true,
      loadingData: true,
      inventoryModalShow: false,
      isFullscreen: false,
      errors_array: [],
      invoiceVolumesBiped: [],
      form: new Form({
        barcode: null,
        invoiceGroupId: null,
        descr: null
      }),
      formModal: new Form({
        invoiceVolumesBiped: [],
      }),
      fields: this.getTableFields(),
      song: new Audio(),
      success: require("../../public/audio/sucesso.mp3"),
      error: require("../../public/audio/erro.mp3"),

      css: {
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
    }
  },
  methods: {
    getTableFields() {
      return [
        {name: "num_fiscal", title: "Nº da nota Fiscal"},
        {name: "serie", title: "Serie"},
        {
          name: "dt_emissao",
          title: "Data Emissão",
          callback: formatToBrazilianDate
        },
        {
          name: "dt_previsao",
          title: "Data Previsão",
          callback: formatToBrazilianDate
        },
        {name: "num_volume", title: "Volume"},
        {name: "emi_cnpj", title: "CNPJ Emi"},
        {name: "emi_nome", title: "Razão Social Emi"},
        {name: "num_lote", title: "Lote"},
        {name: "pallet", title: "Pallet"},
        {name: "status_volume", title: "Status"},
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ];
    },
    onFinished() {
      this.isDisabled = true;
      this.loading = false;
      this.form.reset();

      this.$Simplert.open({
        title: "Deseja finalizar esse grupo?",
        message: "O grupo será finalizado, deseja prosseguir ?",
        customCloseBtnText: "Não",
        customConfirmBtnText: "Sim",
        useConfirmBtn: true,
        type: "warning",
        onConfirm: () => this.confirmFinishGroup(this.invoiceGroupId)
      });

    },
    confirmFinishGroup(invoiceGroupId) {
      this.form
          .post(`/api/inventario/grupo/${invoiceGroupId}/finalizar`)
          .then((response) => {
            this.loading = false;
            this.barcode = ''
            this.$emit('invoiceVolumeInsertOrRemoved');
            this.$snotify.success('Grupo finalizado com sucesso');
            this.onClose();
          })
          .catch((error) => {
            new ReturnApi(error, this);
            this.loading = false;
            this.isDisabled = false;
            this.$Simplert.open({
              title: "Atenção",
              message: error.message,
              customCloseBtnText: "Fechar",
              type: "error",
            })
            
            return;
          });
    },
    onClose() {
      this.barcode = '';
      this.descr = '';
      this.volumesBiped = 0;
      this.inventoryModalShow = false;
      this.invoiceGroupId = null;
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit('setVuetableFilterButton', false);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onShowModalToBeep(data) {
      this.isDisabled = true;
      this.loading = false;
      this.invoiceVolumesBiped = [];
      this.invoiceGroupId = '';
      this.formModal.reset();

      if (data != null) {
        this.formModal
            .get(`/api/inventario/grupo/${data.grupo.docfisvolbipgrp_id}/pendente`)
            .then((response) => {
              new ReturnApi(response, this);
              this.invoiceGroupId = response.docfisvolbipgrp_id;
              this.volumesBiped = response.volumes_bipados;
              this.descr = response.descricao;
              response.doc_fiscal_volume_bip.forEach((volume) => {
                this.invoiceVolumesBiped.push({
                  num_fiscal: volume.doc_fiscal.num_fiscal,
                  serie: volume.doc_fiscal.serie,
                  dt_emissao: volume.doc_fiscal.dt_emissao,
                  dt_previsao: volume.doc_fiscal.dt_previsao,
                  num_lote: volume.doc_fiscal.num_lote,
                  pallet: volume.pallet ? volume.pallet.pallet_id : "N/A",
                  num_volume: volume.doc_fiscal_volume ? volume.doc_fiscal_volume.num_volume : "N/A",
                  emi_cnpj: volume.doc_fiscal.doc_fiscal_partes_env_emi ? volume.doc_fiscal.doc_fiscal_partes_env_emi.emi_cnpj : "N/A",
                  emi_nome: volume.doc_fiscal.doc_fiscal_partes_env_emi ? volume.doc_fiscal.doc_fiscal_partes_env_emi.emi_nome : "N/A",
                  lote: volume.doc_fiscal ? volume.doc_fiscal.num_lote : "N/A",
                  status_volume: volume.doc_fiscal_volume.status.descr,
                  docfisvolbip_id: volume.docfisvolbip_id,
                  docfisvolbipgrp_id: this.invoiceGroupId,
                  descricao: this.descr,
                });
              });
              this.formModal.invoiceVolumesBiped = this.invoiceVolumesBiped;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
              this.loadingData = false;
            });
      }
      this.$refs.inventoryModalForm.show();
    },
    onScan() {
      if (!this.barcode) {
        this.$Simplert.open({
          title: "Código de barra é obrigatório!",
          message: "Por favor, insira o código de barra válido",
          customCloseBtnText: "Fechar",
          customConfirmBtnText: "Fechar",
          useConfirmBtn: false,
          type: "error",
        });
      }
      this.loading = true;
      this.isDisabled = true;

      this.form.barcode = this.barcode;
      this.form.invoiceGroupId = this.invoiceGroupId;
      this.form.descr = this.descr;

      this.form.post('/api/inventario/bip')
          .then((response) => {
            this.playNotify(this.success);
            this.loading = false;
            this.barcode = ''
            this.onShowModalToBeep({
              grupo: {
                docfisvolbipgrp_id: response.docfisvolbipgrp_id
              }
            })
            this.$emit('invoiceVolumeInsertOrRemoved');
            this.$snotify.success('Bipagem efetuada com sucesso');
          })
          .catch((error) => {
            new ReturnApi(error, this);
            this.loading = false;
            this.isDisabled = false;
            this.playNotify(this.error);

            if (error.barcode) {
              return this.$Simplert.open({
                title: "Atenção",
                message: error.barcode.join('\n'),
                customCloseBtnText: "Fechar",
                type: "error",
              })
            }

            this.$Simplert.open({
              title: "Atenção",
              message: error.message,
              customCloseBtnText: "Fechar",
              type: "error",
            })
            this.barcode.focus();
          });
    },
    removeVolumeBeep(data) {
      this.isDisabled = true;
      this.loading = false;
      this.form.reset();

      this.$Simplert.open({
        title: "Deseja remover o volume ?",
        message: "O volume será removido desse grupo, deseja prosseguir ?",
        customCloseBtnText: "Não",
        customConfirmBtnText: "Sim",
        useConfirmBtn: true,
        type: "warning",
        onConfirm: () => this.confirmRemoveVolumeBeep(data)
      });
    },
    confirmRemoveVolumeBeep(data) {
      const sanitizeGroupToUpdateModal = {
        grupo: {
          docfisvolbipgrp_id: data.docfisvolbipgrp_id
        }
      }
      this.form
          .delete(`/api/inventario/grupo/${data.docfisvolbipgrp_id}/volumebip/${data.docfisvolbip_id}/remover`)
          .then((response) => {
            this.loading = true;
            this.isDisabled = true;
            this.onShowModalToBeep(sanitizeGroupToUpdateModal)
            this.$emit('invoiceVolumeInsertOrRemoved');
            this.$snotify.success('Volume removido com sucesso');
          })
          .catch((error) => {
            this.$Simplert.open({
              title: "Atenção",
              message: error.message,
              customCloseBtnText: "Fechar",
              type: "error",
            })
          });
    },
    playNotify(audio) {
      this.song.src = audio;
      this.song.play();
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
}
</script>
